import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faCode, faCoins, faLock, faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

interface SectionItemBarProps {
    title: string;
    to: string;
    xp?: number;
    credit?: number;
    hasBBorder?: boolean; // Bottom border, off for the last item of a section
    typ?: number; // 0 = lesson, anything else = project
    enabled?: boolean; // Locked items are not links
}

const SectionItemBar = ({
                            title,
                            to,
                            xp,
                            credit,
                            hasBBorder = true,
                            typ = 0,
                            enabled = true
                        }: SectionItemBarProps) => {
    const isLesson = typ === 0;

    const content = (
        <div
            className={classNames(
                "flex items-center justify-between gap-x-3 px-10 py-8 border-gray-200",
                hasBBorder ? "border-b-4" : "border-0",
                enabled
                    ? "hover:bg-gray-200 cursor-pointer transition"
                    : "bg-gray-300 opacity-50 cursor-not-allowed"
            )}
        >
            <div className="flex gap-x-5">
                <div
                    className={classNames(
                        "w-12 h-12 text-white text-xl font-bold rounded-full flex items-center justify-center",
                        enabled ? "bg-gray-700" : "bg-gray-400"
                    )}
                >
                    {/* A lock replaces the type icon while the item is locked */}
                    <FontAwesomeIcon
                        icon={!enabled ? faLock : isLesson ? faBook : faCode}
                        size="lg"
                    />
                </div>

                <div>
                    <span className="text-md mb-2 text-gray-600">{isLesson ? "درس" : "پروژه"}</span>
                    <h3 className="font-bold text-xl">{title}</h3>
                </div>
            </div>

            <div className="hidden md:flex items-center text-lg font-bold mr-auto">
                <div className="flex items-center gap-x-3 ml-5">
                    <span>{credit ?? 0}</span>
                    <FontAwesomeIcon icon={faCoins} size="lg" />
                </div>

                <div className="flex items-center gap-x-3">
                    <span>{xp ?? 0}</span>
                    <FontAwesomeIcon icon={faMoneyBill} size="lg" />
                </div>
            </div>
        </div>
    );

    // Locked: plain block that screen readers announce as disabled
    if (!enabled) return <div aria-disabled="true">{content}</div>;

    return <Link to={to}>{content}</Link>;
};

export default SectionItemBar;